module.exports = {"title":"Trivia","body":"<h2><code>♥</code> - это надо знать обязательно, ибо существует неиллюзорная возможность отхватить звездюлей.</h2>\n<h2><code>☠</code> - Ахтунг! За незнание этого вопроса возможен экстерминатус. Ахтунг!</h2>\n"}


//////////////////
// WEBPACK FOOTER
// ./docs/index.md
// module id = 474
// module chunks = 0